<template>
	<div class="detail_container">
		<div class="dcont_bg"></div>
		<div class="dcont_wrap">

			<div class="dcont_card">
				<div class="tit text_center">
					<div>{{reportInfo.hospital}}</div>
					<div>{{reportInfo.reportName}} 检验报告单 </div>
				</div>
				<div class="cont cont_line">
					<div class="cont_item">
						<div class="label">报告时间</div>
						<div class="value">{{reportInfo.time}}</div>
					</div>
				<!-- 	<div class="cont_item">
						<div class="label">报告医生</div>
						<div class="value">{{reportInfo.doctor}}</div>
					</div> -->
					<div class="cont_item">
						<div class="label">检验项目</div>
						<div class="value">{{reportInfo.reportName}}</div>
					</div>
			<!-- 		<div class="cont_item">
						<div class="label">体检时间</div>
						<div class="value">{{reportInfo.time}}</div>
					</div> -->
				</div>
			</div>

			<div class="dcont_card">
				<div class="tit">
					<div>{{reportInfo.reportName}}</div>
				</div>
				<!-- <div class="mid_tips" v-if="resList.length>0">智能医院分析到您有 {{dangerNum}} 项指标存在异常！</div> -->
				<div class="cont res_list">
					<div class="res_item" v-for="(item,index) in resList" :key="index">
						<div class="i_col">
							<div>{{item.detailName}}</div>
							<div v-if="item.jieGuoZCBZ">{{item.jieGuoZCBZ}}</div>
							<div class="i_c_r res_danger" v-if="item.checkResult*1<item.referenceValueF*1 || item.checkResult*1>item.referenceValueE*1">{{item.checkResult}}<div v-if="item.jieGuoDW" style="font-size: 18rpx;">{{item.jieGuoDW}}</div></div>
							<div v-else class="i_c_r" >{{item.checkResult}}<div v-if="item.jieGuoDW" style="font-size: 18rpx;">{{item.jieGuoDW}}</div></div>

						</div>
						<div class="i_col i_col_grey" v-if="item.referenceValueF">
							<div> 参考范围:{{item.referenceValueF}}~{{item.referenceValueE}} </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data () {
    return {
      name: 'reportDetail',
      navIndex: '',
      reportInfo: {},
      resList: [],
      dangerNum: 0
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    // 获取详情信息
    getInfo () {
      let that = this
      let data = this.$route.params
      let reportInfo = {
        hospital: data.baoGaoJGMC,
        reportName: data.jianYanMD,
        time: data.baoGaoSJ,
        doctor: data.BaoGaoRMC
      }
      that.reportInfo = reportInfo
      let list = data.jianYanBGMXForJHPTJKList
      list.forEach((item, index) => {
        let detail = {
          detailName: item.ceShiXMMC,
          checkResult: item.jieGuoZhi,
          referenceValueF: item.zhengChangZXX,
          referenceValueE: item.zhengChangZSX,
          jieGuoDW: item.jieGuoDW,
          jieGuoZCBZ: item.jieGuoZCBZ
        }
        that.resList.push(detail)
      })
      that.calDangerNum()
    },
    calDangerNum () {
      this.dangerNum = 0
      this.resList.forEach(item => {
        if (item.checkResult * 1 < item.referenceValueF * 1 || item.checkResult * 1 > item.referenceValueE * 1) {
          this.dangerNum++
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.detail_container{
	width: 100%;
	padding-bottom: 1px;
	.dcont_bg{
		position: absolute;
		z-index: 0;
		width: 100%;
		height: 130px;
		background-color: #FE9369;
	}
	.dcont_wrap{
		position: relative;
		z-index: 2;
		margin: 0 12px;
		top: 12px;
	}
}
.dcont_card{
	background-color: #fff;
	border-radius: 12px;
	padding: 0 16px;
	margin-bottom: 16px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.1);
	.tit{
		font-size: 16px;
		color: #303133;
		padding: 16px 0;
	}
	.text_center{
		text-align: center;
	}
	.mid_tips{
		border-radius: 4px;
		padding: 6px;
		background: rgba(245, 108, 108, 0.1);
		font-size: 12px;
		color: #F56C6C;
		text-align: center;
	}
	.cont{
		width: 100%;
		padding-bottom: 1px;
		.cont_item{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			margin: 16px 0;
			.label{
				color: #919398;
			}
			.value{
				width: 160px;
				text-align: right;
				color: #303133;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
		.card_info{
			font-size: 14px;
			color: #606266;
			padding: 16px 0;
		}
	}
	.cont_line{
		border-top: solid 0.5px #E5E7ED;
	}
}
.res_item{
	padding: 12px 0;
	line-height: 26px;
	border-bottom: solid 0.5px #EBEEF5;
	.i_col{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
		color: #303133;
		.i_c_r{
			display: flex;
		}
		.res_danger{
			color: #F94242;
		}
	}
	.i_col_grey{
		font-size: 14px;
		color: #919398;
	}
}
.res_item:last-child{
	border:none;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/pages/report/report-detail.vue